export enum REVIEW_TABS {
  HOME = 'HOME',
  REVIEWS = 'REVIEWS',
  METRICS = 'METRICS',
  KEYWORDS = 'KEYWORDS',
  GOOGLE = 'GOOGLE REVIEWS',
  YELP = 'YELP REVIEWS',
  OTHER_REVIEWS = 'OTHER REVIEWS'
}

/** Selectable directory for the "Other reviews" tab; `value` is the reviews API path segment. */
export interface IReviewTypeOption {
  label: string;
  value: string;
}

/** Directories available in the "Other reviews" switcher, in display order. First entry is the default. */
export const PANDIO_REVIEW_TYPES: IReviewTypeOption[] = [
  { label: 'Healthgrades', value: 'healthgrades' },
  { label: 'Vitals', value: 'vitals' },
  { label: 'RateMDs', value: 'ratemds' },
];
